'use client';
import axios from 'axios';
import type { TranslationValues } from 'next-intl';
import { useEffect, useState } from 'react';

type ErrorProps = {
  message: string | null;
  details: TranslationValues;
};

export const useError = (err?: unknown) => {
  const [error, setError] = useState<ErrorProps>({ message: null, details: {} });

  useEffect(() => {
    if (axios.isAxiosError(err)) {
      setError({ message: err.response?.data.error.message, details: err.response?.data.error.details });
    }
  }, [err]);

  return {
    error,
    setError
  };
};
